import FormSearchField from '../../FormSearchField/FormSearchField';
import type { FieldRendererProps } from '../types';

export function SearchField({ field, formType, onChange, onFormRefresh }: FieldRendererProps) {
  return (
    <FormSearchField
      fieldID={field.id.toString()}
      fieldEntityID={field.entityID.toString()}
      value={field.value}
      formType={formType}
      isDisabled={!!field.disabled}
      onChange={onChange}
      onRefresh={onFormRefresh}
    />
  );
}
